import styled from "styled-components";

// สีสถานะห้องซ้อม ตามที่ลูกค้ากำหนด: ไม่ว่าง / รอยืนยัน / ว่าง
const ROOM_STATUS_COLOR = {
  full: "#5F5D5A",
  pending: "#EF9F27",
  available: "#B5A2C7",
  closed_day: "#E3E1E6", // วันปิดประจำ (เช่น ห้องซ้อมวันจันทร์) อ่อนกว่า "ไม่ว่าง" ให้เห็นว่าเป็นวันหยุด ไม่ใช่คิวเต็ม
};

export const CelendarWidgetStyled = styled.div`
  .cd_header_row {
    margin-bottom: 10px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    .top_left {
      color: ${({ theme }) => theme.COLORS.PURPLE_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S15};
    }
    .action_next_prev_block {
      display: flex;
      column-gap: 14px;
      text-decoration: underline;
      .top_right {
        cursor: pointer;
        color: ${({ theme }) => theme.COLORS.PURPLE_1};
        font-size: ${({ theme }) => theme.FONT.SIZE.S15};
        font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_REGULAR};
      }
    }
  }
  .status_legend {
    margin-bottom: 10px;
    display: flex;
    flex-wrap: wrap;
    row-gap: 6px;
    .status_detail {
      margin-right: 12px;
      height: 15px;
      display: flex;
      align-items: center;
      .box {
        width: 26px;
        height: 15px;
        margin-right: 10px;
        &.full {
          border: 1px solid ${({ theme }) => theme.COLORS.RED_3}69;
          background: ${({ theme }) => theme.COLORS.RED_3}69;
        }
        &.almost {
          border: 1px solid ${({ theme }) => theme.COLORS.PURPLE_7}66;
          background: ${({ theme }) => theme.COLORS.PURPLE_7}66;
        }
        &.available {
          border: 1px solid ${({ theme }) => theme.COLORS.PURPLE_1}69;
          background: ${({ theme }) => theme.COLORS.PURPLE_1}69;
        }
      }
      .status_title {
        color: ${({ theme }) => theme.COLORS.PURPLE_1};
        font-size: ${({ theme }) => theme.FONT.SIZE.S12};
      }
    }
    &.room {
      .status_detail {
        height: 22px;
        .box {
          width: 36px;
          height: 22px;
          display: flex;
          justify-content: center;
          align-items: center;
          &.full {
            border-color: ${ROOM_STATUS_COLOR.full};
            background: ${ROOM_STATUS_COLOR.full};
          }
          &.pending {
            border-color: ${ROOM_STATUS_COLOR.pending};
            background: ${ROOM_STATUS_COLOR.pending};
          }
          &.available {
            border-color: ${ROOM_STATUS_COLOR.available};
            background: ${ROOM_STATUS_COLOR.available};
          }
          &.closed_day {
            border-color: ${ROOM_STATUS_COLOR.closed_day};
            background: ${ROOM_STATUS_COLOR.closed_day};
          }
        }
      }
    }
  }
  .cd_body {
    margin-bottom: 30px;
    display: grid;
    grid-template-columns: 50px repeat(7, minmax(0, 1fr));
    grid-auto-rows: 30px;
    gap: 5px;
    .time_cell,
    .day_cell,
    .data_cell {
      box-sizing: border-box;
      padding: 2px;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
      white-space: pre-wrap;
      line-height: 14px;
    }
    .time_cell {
      color: ${({ theme }) => theme.COLORS.WHITE_1};
      background: ${({ theme }) => theme.COLORS.PURPLE_9};
      font-size: ${({ theme }) => theme.FONT.SIZE.S10};
      &.f_16 {
        font-size: ${({ theme }) => theme.FONT.SIZE.S12};
      }
    }
    .day_cell {
      flex-direction: column;
      background: ${({ theme }) => theme.COLORS.PURPLE_1};
      color: ${({ theme }) => theme.COLORS.WHITE_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S11};
    }
    .data_cell {
      border: 1px solid ${({ theme }) => theme.COLORS.PURPLE_1}69;
      background: #707070;
      color: #ffffff;
    }
    &.room {
      gap: 3px;
      .time_cell:not(.f_16) {
        color: #000000;
        background: #ced4da;
      }
      .data_cell {
        border: none;
        background: ${ROOM_STATUS_COLOR.available};
        &.full {
          background: ${ROOM_STATUS_COLOR.full};
        }
        &.pending {
          background: ${ROOM_STATUS_COLOR.pending};
        }
        &.available {
          background: ${ROOM_STATUS_COLOR.available};
        }
        &.closed_day {
          height: auto;
          background: ${ROOM_STATUS_COLOR.closed_day};
          color: ${({ theme }) => theme.COLORS.PURPLE_1};
          font-size: ${({ theme }) => theme.FONT.SIZE.S12};
          writing-mode: vertical-rl;
          letter-spacing: 2px;
        }
      }
    }
  }

  &.theme_bosendorfer {
    .cd_header_row {
      margin-bottom: 7px;
      .top_left {
        color: ${({ theme }) => theme.COLORS.GRAY_8};
        font-size: ${({ theme }) => theme.FONT.SIZE.S18};
        font-family: ${({ theme }) => theme.FONT.STYLE.GLACIAL_INDIFFERENCE_REGULAR};
      }
      .action_next_prev_block {
        .top_right {
          text-decoration: underline;
          color: ${({ theme }) => theme.COLORS.GOLD_2};
          font-size: ${({ theme }) => theme.FONT.SIZE.S18};
          font-family: ${({ theme }) => theme.FONT.STYLE.GLACIAL_INDIFFERENCE_REGULAR};
        }
      }
    }
    .status_legend {
      .status_detail {
        .box {
          border: 1px solid ${({ theme }) => theme.COLORS.GOLD_2};
          &.full {
            background: #00000069;
          }
          &.almost {
            background: #96969669;
          }
          &.available {
            background: #ffffff;
          }
        }
        .status_title {
          color: ${({ theme }) => theme.COLORS.GOLD_2};
          font-size: ${({ theme }) => theme.FONT.SIZE.S12};
          font-family: ${({ theme }) => theme.FONT.STYLE.GLACIAL_INDIFFERENCE_REGULAR};
        }
      }
    }
    .cd_body {
      margin-bottom: 43px;
      .time_cell,
      .day_cell {
        background: ${({ theme }) => theme.COLORS.GOLD_2};
      }
      .data_cell {
        border: 1px solid ${({ theme }) => theme.COLORS.GOLD_2};
      }
    }
  }
`;
